import { render } from "./SingleNews.vue?vue&type=template&id=70896900&scoped=true"
import script from "./SingleNews.vue?vue&type=script&lang=js"
export * from "./SingleNews.vue?vue&type=script&lang=js"

import "./SingleNews.vue?vue&type=style&index=0&id=70896900&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70896900"]])

export default __exports__